import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  commentWrapper: {
    borderRadius: 4,
    padding: 8,
    width: '100%',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  userInfo: {
    marginLeft: 8,
    display: 'flex',
    flexDirection: 'column',
  },
  editedCommentContent: {},
  editedCommentBottom: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 8,
  },
  uploadFileButton: {
    height: 32,
    lineHeight: '24px',
    padding: '4px 8px',
    display: 'inline-flex',
    marginBottom: 4,
  },

  filesWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  repliedCommentWrapper: {
    borderLeft: `${theme.palette.primary.main} 2px solid`,
    margin: theme.spacing(1, 0),
  },

  createdAt: {
    color: theme.palette.grey[600],
  },
  commentContent: {
    textOverflow: 'ellipsis',
    whiteSpace: 'pre-wrap',
    overflow: 'hidden',
  },
}));
